import React, { FC } from 'react';
import classNames from 'classnames';

import styles from './ModalFooter.module.css';

export type ModalFooterProps = {
  children: React.ReactNode;
} & React.HTMLProps<HTMLDivElement>;

const Body: FC<ModalFooterProps> = ({
  children,
  className,
  ...props
}: ModalFooterProps) => {
  const containerClass = classNames(styles.container, className);

  return (
    <div className={containerClass} {...props}>
      {children}
    </div>
  );
};

export default Body;
